import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import InquiryForm from './InquiryForm'

const vaccinations = [
  { name: 'Yellow Fever', desc: 'Required for travel to parts of Africa and South America, and often mandatory for entry or transit.' },
  { name: 'Meningitis (ACWY)', desc: 'Mandatory for pilgrims traveling for Hajj and Umrah to Saudi Arabia.' },
  { name: 'Polio (OPV/IPV)', desc: 'Recommended or required for travel to select countries with ongoing polio transmission.' },
  { name: 'Hepatitis A & B', desc: 'Recommended for most international travelers, especially to regions with limited sanitation.' },
  { name: 'Typhoid', desc: 'Recommended for travelers visiting areas with a risk of contaminated food or water.' },
  { name: 'COVID-19', desc: 'Some destinations may still require proof of vaccination or a recent negative test.' },
  { name: 'Influenza (Flu)', desc: 'Recommended, particularly during peak travel seasons and for group travel such as Hajj/Umrah.' },
  { name: 'Tetanus & Diphtheria', desc: 'Routine booster recommended for all travelers every 10 years.' },
]

function VisaVaccination() {
  const [InquiryFormOpen, setInquiryFormOpen] = useState(false)

  return (
    <div>
      <InquiryForm isOpen={InquiryFormOpen} setIsOpen={setInquiryFormOpen} />

      <div
        className="container-fluid bg-primary py-5 mb-5 hero-header"
        style={{
          background: `linear-gradient(rgba(0, 0, 0, 0.856), rgba(79, 79, 79, 0.801)), url(${process.env.PUBLIC_URL}/assets/img/hajjpackage.jpg)`,
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      >
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                Visa Vaccination
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item text-white active" aria-current="page">
                    Visa Vaccination
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Health & Travel Requirements
            </h6>
            <h1 className="mb-5">Vaccination Requirements for Your Trip</h1>
          </div>
          <p className="text-center mb-5">
            Certain destinations require proof of vaccination before entry or visa approval. Our team helps you
            identify the right vaccinations for your destination and assists with documentation and scheduling.
          </p>
          <div className="row g-4">
            {vaccinations.map((item, index) => (
              <div key={index} className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
                <div className="service-item rounded pt-3 h-100">
                  <div className="p-4">
                    <i className="fa fa-syringe fa-3x text-primary mb-3" />
                    <h5>{item.name}</h5>
                    <p>{item.desc}</p>
                    <Link
                      to={`/VisaVaccination/certificate/${encodeURIComponent(item.name)}`}
                      className="btn btn-sm btn-primary px-3"
                      style={{ borderRadius: '0 30px 30px 0' }}
                    >
                      Get Certificate
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default VisaVaccination
